import React from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { tokens } from "../theme";
import { dataGridStyles, localeText } from "../utils/dataGridConfig";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { getTicketTypeByValue } from "../constants/enums";

const TicketsList = ({ ticketsList, setTicketsList, setSelectedTicket, isReadOnly = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Use the provided ticketsList
  const tickets = ticketsList || [];

  // Function to handle the deletion of a ticket
  const handleDeleteTicket = (id) => {
    if (ticketsList && setTicketsList) {
      const updatedTickets = ticketsList.filter((ticket) => ticket.id !== id);
      setTicketsList(updatedTickets);
    }
  };

  // Function to handle row click
  const handleRowClick = (params) => {
    if (setSelectedTicket) {
      setSelectedTicket(params.id); // Pass the selected ticket ID to the parent component
    }
  };

  // Define columns for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "day",
      headerName: "Día",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "type",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => {
        const typeInfo = getTicketTypeByValue(params.value);
  
        return (
        <Box
          sx={{
            color: typeInfo.color,
            fontWeight: "bold",
            backgroundColor: `${typeInfo.color}30`, // Transparent background
            border: ` ${typeInfo.color}`, // Corner borders
            borderRadius: "8px", // Rounded corners
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "60%",
            height: "50%",
            textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
            overflow: "hidden", // Prevent shadow from going outside the box
          }}
        >
          {typeInfo.label}
        </Box>
        );
      },
    },
  ];

  // Add the "Actions" column only if isReadOnly is false
  if (!isReadOnly) {
    columns.push({
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteOutlinedIcon />}
          label="Delete"
          onClick={() => handleDeleteTicket(params.id)}
        />,
      ],
    });
  }

  return (
    <Box height="40vh" sx={dataGridStyles(colors)}>
      <DataGrid
        rows={tickets}
        columns={columns}
        getRowId={(row) => row.id}
        pageSizeOptions={[100]}
        loadingText="Cargando..."
        localeText={localeText}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        onRowClick={handleRowClick} // Add the row click handler
      />
    </Box>
  );
};

export default TicketsList;